/*= ========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// import moduleTodo from './todo/moduleTodo'
// import moduleCalendar from './calendar/moduleCalendar'
// import moduleChat from './chat/moduleChat'
// import moduleEmail from './email/moduleEmail'
// import eCommerce from './eCommerce/moduleECommerce';
import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    ...modules
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    // auth: moduleAuth,
    // eCommerce
  },
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
